"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAvoProvider = void 0;
const avo_options_1 = require("./avo-options");
const react_1 = require("react");
const react_2 = __importDefault(require("react"));
const DefaultAvoProvider = ({ children, Avo }) => {
    // we used useMemo instead of useEffect to trigger the init sooner (basically componentWillMount vs componentDidMount)
    (0, react_1.useMemo)(() => {
        Avo.initAvo(...(0, avo_options_1.getDefaultAvoOptions)(Avo.avoInspectorApiKey));
    }, [Avo]);
    return react_2.default.createElement(react_2.default.Fragment, null, children);
};
exports.DefaultAvoProvider = DefaultAvoProvider;
//# sourceMappingURL=DefaultAvoProvider.js.map